



























import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import Idf1 from './datasource-form-tab1.vue';
import Idf2 from './datasource-form-tab2.vue';
import CategoryServices, { CategoryDto } from '@/services/category';
import DatasourceServices, { DatasourceDto, ColumnConfig, KafkaConfig, KafkaConf } from '@/services/datasource';
import { Watch } from 'vue-property-decorator';
import { Mutation, namespace } from 'vuex-class';
const System = namespace('System');
@Component({
  components: { Idf1, Idf2 }
})
export default class DatasourceForm extends mixins(BaseFormMixin) {
  dsSrv = new DatasourceServices();
  categorySrv = new CategoryServices();
  canSave = false;
  formData: any = {};
  keepalive: boolean = true;
  breadList = [{ name: '创建数据源' }];

  id: any = 0;
  dsCategoryId: any = '';
  tables: Array<ColumnConfig> = [];
  showTable = true;
  dsCategory: any = '';
  dsType: any = '';

  created() {
    this.id = this.$route.query.id;
    this.dsCategoryId = this.$route.query.categoryId;
    this.initFormData();
  }

  activated() {
    this.onIdChange();
  }

  initFormData() {
    this.formData = {
      dsCategoryId: this.dsCategoryId,
      dsCategoryName: '',
      dsType: 'MySql',
      dsCategory: 'SQL',
      status: 0,
      dsConfig: {},
      esConf: {},
      fileConfig: {},
      storageConfig: {},
      kafkaConf: {},
      kafkaConfDto: {},
      hiveConf: {},
      dorisConf: {},
      columnConfig: []
    };
    this.current = 0;
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.dsCategoryId = this.$route.query.categoryId;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('id')
  async onIdChange() {
    let path = this.$route.path;
    if (path == '/data/datasource/add') {
      this.refreshKeepalive();
      if (this.keepalive && this.cache) return false;
      this.initFormData();
      this.current = 0;
      let category = await this.categorySrv.getInfo(this.dsCategoryId);
      this.breadList = [{ name: category.categoryName }, { name: '创建数据源' }];
    } else if (path == '/data/datasource/edit') {
      if ((!this.id || this.id == this.formData.id) && this.cache) return false;
      this.spinning = true;
      let res = await this.dsSrv.getInfo(this.id);
      this.spinning = false;
      this.formData = res;
      this.dsCategory = res.dsCategory;
      this.dsType = res.dsType.toLowerCase();
      if (this.dsType === 'kafka') {
        this.toKafkaDto(this.formData.kafkaConf);
      }else if (this.dsType === 'hive') {
        if (this.formData.hiveConf && this.formData.hiveConf.hadoopConfig) {
          let hadoopInputStr = JSON.stringify(this.formData.hiveConf.hadoopConfig);
          this.formData.hiveConf.hadoopInput = hadoopInputStr;
        }
      }
      this.current = 0;
      this.breadList = [{ name: res.dsCategoryName || '' }, { name: res.dsName || '' }, { name: '编辑数据源' }];
    }
  }

  loading: boolean = false;
  async confirm() {
    let ret = this.checkDs();
    if (!ret) {
      return false;
    }

    this.loading = true;
    //如果是修改 更新数据库
    if (this.id) {
      let res = await this.dsSrv.update(this.id, this.formData);
      if (res) {
        this.replaceUrlWithOutConfirm('/data/datasource/detail?id=' + this.id);
      }
    } else {
      let source = await this.dsSrv.add(this.formData);
      if (!source) return false;
      this.id = source.id;
      this.formData.id = source.id;
      this.replaceUrlWithOutConfirm('/data/datasource/detail?id=' + this.formData.id);
    }
    
    this.loading = false;
    this.HANDLE_RELOAD_DS_MENU();
  }
  @Mutation HANDLE_RELOAD_DS_MENU: any;

  toKafkaConf(kafkaDto: KafkaConfig) {
    this.formData.kafkaConf.bootstrapServers = [kafkaDto.bootstrapServers];
    this.formData.kafkaConf.consumer = {
        bootstrapServers: kafkaDto.bootstrapServers,
        groupId: kafkaDto.groupId,
        topic: kafkaDto.topic,
        securityProtocol: kafkaDto.securityProtocol,
        sslKeyPassword: kafkaDto.sslKeyPassword,
        // securityProtocol = SSL 
        sslKeystoreLocation: kafkaDto.sslKeystoreLocation,
        sslKeystorePassword: kafkaDto.sslKeystorePassword,
        sslKeystoreBase64: kafkaDto.sslKeystoreBase64,
        sslTruststoreLocation: kafkaDto.sslTruststoreLocation,
        sslTruststorePassword: kafkaDto.sslTruststorePassword,
        sslTruststoreBase64: kafkaDto.sslTruststoreBase64,
        // securityProtocol = SASL_PLAINTEXT PLAIN
        saslMechanism: kafkaDto.saslMechanism, 
        saslUerName: kafkaDto.saslUerName,
        saslPassword: kafkaDto.saslPassword,
        krbKeyTab: kafkaDto.krbKeyTab,
        krbKeyTabBase64: kafkaDto.krbKeyTabBase64,
        krbPrincipal: kafkaDto.krbPrincipal,
        // "org.apache.kafka.common.security.plain.PlainLoginModule required username=\"producer\" password=\"prod-test\";"
        saslJaasConfig: kafkaDto.saslJaasConfig,
        // earliest,lastest,none
        autoOffsetReset: kafkaDto.autoOffsetReset
    };
    this.formData.kafkaConf.schema = { url: kafkaDto.schemaUrl }
    this.formData.kafkaConf.producer = {
        bootstrapServers: kafkaDto.bootstrapServers,
        topic: kafkaDto.topic,
        securityProtocol: kafkaDto.securityProtocol,
        sslKeyPassword: kafkaDto.sslKeyPassword,
        // securityProtocol = SSL 
        sslKeystoreLocation: kafkaDto.sslKeystoreLocation,
        sslKeystorePassword: kafkaDto.sslKeystorePassword,
        sslKeystoreBase64: kafkaDto.sslKeystoreBase64,
        sslTruststoreLocation: kafkaDto.sslTruststoreLocation,
        sslTruststorePassword: kafkaDto.sslTruststorePassword,
        sslTruststoreBase64: kafkaDto.sslTruststoreBase64,
        // securityProtocol = SASL_PLAINTEXT PLAIN
        saslMechanism: kafkaDto.saslMechanism, 
        saslUerName: kafkaDto.saslUerName,
        saslPassword: kafkaDto.saslPassword,
        krbKeyTab: kafkaDto.krbKeyTab,
        krbKeyTabBase64: kafkaDto.krbKeyTabBase64,
        krbPrincipal: kafkaDto.krbPrincipal,
        // "org.apache.kafka.common.security.plain.PlainLoginModule required username=\"producer\" password=\"prod-test\";"
        saslJaasConfig: kafkaDto.saslJaasConfig
    };
  }

  toKafkaDto(kafkaConf: KafkaConf) {
    if (kafkaConf && kafkaConf.consumer) {
      this.formData.kafkaConfDto = {
          bootstrapServers: kafkaConf.consumer.bootstrapServers,
          groupId: kafkaConf.consumer.groupId,
          topic: kafkaConf.consumer.topic,
          securityProtocol: kafkaConf.consumer.securityProtocol,
          sslKeyPassword: kafkaConf.consumer.sslKeyPassword,
          // securityProtocol = SSL 
          sslKeystoreLocation: kafkaConf.consumer.sslKeystoreLocation,
          sslKeystorePassword: kafkaConf.consumer.sslKeystorePassword,
          sslKeystoreBase64: kafkaConf.consumer.sslKeystoreBase64,
          sslTruststoreLocation: kafkaConf.consumer.sslTruststoreLocation,
          sslTruststorePassword: kafkaConf.consumer.sslTruststorePassword,
          sslTruststoreBase64: kafkaConf.consumer.sslTruststoreBase64,
          // securityProtocol = SASL_PLAINTEXT PLAIN
          saslMechanism: kafkaConf.consumer.saslMechanism,
          saslUerName: kafkaConf.consumer.saslUerName,
          saslPassword: kafkaConf.consumer.saslPassword,
          krbKeyTab: kafkaConf.consumer.krbKeyTab,
          krbKeyTabBase64: kafkaConf.consumer.krbKeyTabBase64,
          krbPrincipal: kafkaConf.consumer.krbPrincipal,
          // "org.apache.kafka.common.security.plain.PlainLoginModule required username=\"producer\" password=\"prod-test\";"
          saslJaasConfig: kafkaConf.consumer.saslJaasConfig,
          // earliest,lastest,none
          autoOffsetReset: kafkaConf.consumer.autoOffsetReset,
          schemaUrl: kafkaConf.schema? kafkaConf.schema.url : ''
      };
    }
  }

  async testDatasrouce() {
    let ret = this.checkDs();
    if (!ret) {
      return false;
    }

    let res = await this.dsSrv.test(this.formData);
    if (res) {
      this.$message.success('测试成功！');
      this.canSave = true;
    } else {
      this.$message.error('连接失败!');
    }
  }

  checkDs() {
    const must: { field: 'dsCode' | 'dsName'; msessage: string }[] = [
        { field: 'dsCode', msessage: '数据源编码不能为空' },
        { field: 'dsName', msessage: '数据源名称不能为空' }
    ];
    for (let val of must) {
      if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
      }
    }

    if (this.formData.dsType.toLowerCase().includes('mysql', 'postgresql', 'sqlserver', 'oracle', 'doris')) {
        const mustDs: { field: 'ipAddr' | 'port' | 'dbInstance'| 'username'; msessage: string }[] = [
          { field: 'ipAddr', msessage: '数据库地址不能为空' },
          { field: 'port', msessage: '数据库端口不能为空' },
          { field: 'dbInstance', msessage: '数据库实例名称不能为空' },
          { field: 'username', msessage: '数据库用户名不能为空' },
        ];
        for (let val of mustDs) {
          if (!this.formData.dsConfig[val.field]) {
            this.$message.error(val.msessage);
            return false;
          }
        }
    } else if (this.formData.dsType.toLowerCase().includes('elasticsearch')) {
        const mustDs: { field: 'hostsInput' | 'username'; msessage: string }[] = [
          { field: 'hostsInput', msessage: '数据库集群地址不能为空' },
          { field: 'username', msessage: '数据库用户名不能为空' },
        ];
        for (let val of mustDs) {
          if (!this.formData.esConf[val.field]) {
            this.$message.error(val.msessage);
            return false;
          }
        }
    } else if (this.formData.dsType.toLowerCase().includes('hive')) {
        const mustDs: { field: 'jdbcUrl' | 'schema' | 'username'; msessage: string }[] = [
          { field: 'jdbcUrl', msessage: 'HIVE JDBC URL不能为空' },
          { field: 'schema', msessage: 'HIVE数据库名称不能为空' },
          { field: 'username', msessage: 'HIVE用户名不能为空' },
        ];
        for (let val of mustDs) {
          if (!this.formData.hiveConf[val.field]) {
            this.$message.error(val.msessage);
            return false;
          }
        }
        // TODO hive.hadoopConfig
        debugger
        if (this.formData.hiveConf && this.formData.hiveConf.hadoopInput) {
          let jsonConfig = JSON.parse(this.formData.hiveConf.hadoopInput);
          this.formData.hiveConf.hadoopConfig = jsonConfig;
        }
    } else if (this.formData.dsType && this.formData.dsType.toLowerCase() === 'kafka') {
      const mustKafka: { field: 'bootstrapServers'; msessage: string }[] = [
        { field: 'bootstrapServers', msessage: 'Kafka集群地址不能为空' }
      ];
      for (let val of mustKafka) {
        if (!this.formData.kafkaConfDto[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
      this.toKafkaConf(this.formData.kafkaConfDto);
    }
    return true;
  }

  // jdbc用dsConfig，kafka用kafkaConf，es用esConf，csvfile用fileConfig，oss用storageConfig

  async next() {
    if (this.current === 0) {
      const must: { field: 'dsType'; message: string }[] = [{ field: 'dsType', message: '请选择数据源类型' }];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.message);
          return false;
        }
      }
    } else if (this.current === 1) {
      const must: { field: 'dsCode' | 'dsName'; message: string }[] = [
        { field: 'dsCode', message: '请录入数据源代码' },
        { field: 'dsName', message: '请录入数据源名称' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.message);
          return false;
        }
      }

      if (this.formData.dsType && this.formData.dsType.indexOf('File') > 0) {
        //文件
        if (this.tables && this.tables.length === 0) {
          let fileTable = {
            tableNameEn: 'File',
            tableNameCn: '文件',
            inputFlag: 0,
            outputFlag: 0,
            status: 0
          };
          this.tables = [fileTable];
        }
      } else {
        //jdbc
        // let dbRes = await this.dsSrv.databases(this.formData);
        // console.log('dbres', dbRes);
        //保存
        this.loading = true;
        if (!this.formData.id) {
          let source = await this.dsSrv.add(this.formData);
          this.id = source.id;
          this.formData.id = source.id;
        }
        this.showTable = false;
        this.tables = await this.dsSrv.tables({ sourceId_eq: this.id });
        this.showTable = true;
        this.loading = false;
      }
    }
    this.current++;
  }
}
